import {Injectable, NgZone} from '@angular/core';
import {Observable, Observer} from 'rxjs';

import {ExgMapInfoWindowComponent} from '../../exg-map-info-window/exg-map-info-window.component';

import {ExgMapGoogleAPIWrapper} from '../exg-map-google-api-wrapper.service';
import {ExgMapMarkerManagerService} from './exg-map-marker-manager.service';
import {resolve} from '@angular/compiler-cli/src/ngtsc/file_system';

@Injectable()
export class ExgMapInfoWindowManagerService {
  private _infoWindows: Map<ExgMapInfoWindowComponent, Promise<google.maps.InfoWindow>> =
    new Map<ExgMapInfoWindowComponent, Promise<google.maps.InfoWindow>>();

  constructor(
    private _mapsWrapper: ExgMapGoogleAPIWrapper, private _zone: NgZone,
    private _markerManager: ExgMapMarkerManagerService) {
  }

  deleteInfoWindow(infoWindow: ExgMapInfoWindowComponent): Promise<void> {
    const iWindow = this._infoWindows.get(infoWindow);
    if (iWindow == null) {
      // info window already deleted
      return Promise.resolve();
    }
    return iWindow.then((i: google.maps.InfoWindow) => {
      return this._zone.run(() => {
        i.close();
        this._infoWindows.delete(infoWindow);
      });
    });
  }

  setPosition(infoWindow: ExgMapInfoWindowComponent): Promise<void> {
    // @ts-ignore
    return this._infoWindows.get(infoWindow).then((i: google.maps.InfoWindow) => i.setPosition({
      lat: infoWindow.latitude as number,
      lng: infoWindow.longitude as number,
    }));
  }

  setZIndex(infoWindow: ExgMapInfoWindowComponent): Promise<void> {
    // @ts-ignore

    return this._infoWindows.get(infoWindow)
      // @ts-ignore
      .then((i: google.maps.InfoWindow) => i.setZIndex(infoWindow.zIndex));
  }

  open(infoWindow: ExgMapInfoWindowComponent): Promise<void> {
    // @ts-ignore
    return this._infoWindows.get(infoWindow).then((w) => {
      if (infoWindow.hostMarker != null) {
        // @ts-ignore
        return this._markerManager.getNativeMarker(infoWindow.hostMarker).then((marker) => {
          return this._mapsWrapper.getNativeMap().then((map) => w.open(map, marker));
        });
      }
      return this._mapsWrapper.getNativeMap().then((map) => w.open(map));
    });
  }

  close(infoWindow: ExgMapInfoWindowComponent): Promise<void> {
    // @ts-ignore
    return this._infoWindows.get(infoWindow).then((w) => w.close());
  }

  closeAll(infoWindow: ExgMapInfoWindowComponent): void {
    this._infoWindows.forEach((value, key) => {
      if (key !== infoWindow) {
        key.isOpen = false;
        value.then((e) => {
          e.close();
        });
      }
    });
  }

  setOptions(infoWindow: ExgMapInfoWindowComponent, options: google.maps.InfoWindowOptions): void {
    // @ts-ignore
    return this._infoWindows.get(infoWindow).then((i: google.maps.InfoWindow) => i.setOptions(options));
  }

  addInfoWindow(infoWindow: ExgMapInfoWindowComponent): void {
    const options: google.maps.InfoWindowOptions = {
      content: infoWindow.content as any,
      maxWidth: infoWindow.maxWidth,
      zIndex: infoWindow.zIndex,
      disableAutoPan: infoWindow.disableAutoPan,
    };
    if (typeof infoWindow.latitude === 'number' && typeof infoWindow.longitude === 'number') {
      options.position = {lat: infoWindow.latitude, lng: infoWindow.longitude};
    }
    const infoWindowPromise = this._mapsWrapper.createInfoWindow(options);
    this._infoWindows.set(infoWindow, infoWindowPromise);
  }

  /**
   * Creates a Google Maps event listener for the given InfoWindow as an Observable
   */
  createEventObservable<T>(eventName: string, infoWindow: ExgMapInfoWindowComponent): Observable<T> {
    return new Observable((observer: Observer<T>) => {
      // @ts-ignore
      this._infoWindows.get(infoWindow).then((i: google.maps.InfoWindow) => {
        // @ts-ignore
        i.addListener(eventName, (e: T) => this._zone.run(() => observer.next(e)));
      });
    });
  }
}
